module.exports = __webpack_public_path__ + "img/263.82810797.svg";